/**
 * Determines whether two strings are different after trimming whitespace from both ends.
 *
 * @param left - The first string to compare.
 * @param right - The second string to compare.
 * @returns `true` if the trimmed strings are not equal; otherwise, `false`.
 */
export function isStringDirty(left: string, right: string): boolean {
	return left.trim() !== right.trim();
}
